import type { HTMLAttributes, ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface FeatureCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export function FeatureCard({ children, className, ...props }: FeatureCardProps) {
  return (
    <div
      className={twMerge(
        "w-full h-[400px] border border-border-default rounded-xl bg-bg-surface relative overflow-hidden pl-8 pt-8",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}
